import { render, staticRenderFns } from "./TimeIrkutsk.vue?vue&type=template&id=beae983e&scoped=true"
import script from "./TimeIrkutsk.vue?vue&type=script&lang=js"
export * from "./TimeIrkutsk.vue?vue&type=script&lang=js"
import style0 from "./TimeIrkutsk.vue?vue&type=style&index=0&id=beae983e&prod&lang=scss&scoped=true"
import style1 from "./TimeIrkutsk.vue?vue&type=style&index=1&id=beae983e&prod&lang=scss"
import style2 from "./TimeIrkutsk.vue?vue&type=style&index=2&id=beae983e&prod&lang=scss&scoped=true"
import style3 from "./TimeIrkutsk.vue?vue&type=style&index=3&id=beae983e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beae983e",
  null
  
)

export default component.exports